import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import sty from './martcard.module.css'
import style from "../UIElements/Form_label/FormLabels.module.css";
import { validEmailRegex, mobilenumberRegex, ifscRegex, validateForm, pan, gstNumber } from '../RegxConst'
import { Form, Button, Table } from 'react-bootstrap';
import { TitleHeading } from '../UIElements/headings/TitleHeading';
import styles from '../listings/forms/addpost.module.css';
import BillBoard from '../advertisements/BillBoard';
import LargeRectangle from '../advertisements/LargeRectangle';
import { notifyUser, type } from '../utility/notifyUser';
import SetLocation from '../SetFilters/SetLocation/SetLocation';
import authservice from '../Authentication/service/authservice';
import { DatePicker, TimePicker } from 'antd';
import moment from 'moment';
import { matchPath } from "react-router-dom";
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import SetMartCategory from "../SetFilters/SetCategory/SetMartCategory";

const EditMart = (props) => {
    const { id } = useParams()
    const location = useLocation();
    const history = useHistory();
    const [readOnlyMode, setReadOnlyMode] = useState(false);
    const [formVisible, setFormVisible] = useState(false);
    const [thumbnailImage, setThumbnailImage] = useState(null);
    const [panImage, setPanImage] = useState(null);
    const [certificateImage, setCertificateImg] = useState(null);
    const [isThumbnailPicValid, setIsThumbnailPicValid] = useState(false);
    const [errors, setErrors] = useState({});
    const [martType, setMartType] = useState('');
    const [formData, setFormData] = useState({
        id: null,
        martName: "",
        businessDescription: "",
        businessAddress: "",
        contactName: "",
        contactNumber: "",
        minOrderValue: "",
        thumbnailDescription: "",
        thumbnailImage: null,
        homeDeliveryAvailable: false,
        // pickupAvailable: false,
        categories: [],
        subCategories: [],
        certifications: [],
        workingHours: [],
        openingHoursList: [],
        country: [],
        states: [],
        statesAll: [],
        cities: [],
        localities: [],
        neighbourhoods: [],
        bankName: "",
        accountHolderName: "",
        bankAccountNumber: "",
        ifsc: "",
        panNum: "",
        panImage: null,
        gstNumber: "",
    });
    const [marts, setMarts] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [categoryValidation, setCategoryValidation] = useState(null);
    const [subCategoryValidation, setSubCategoryValidation] = useState(null);
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [allLocations, setAllLocations] = useState([]);
    const [bankAccountNumber, setBankAccountNumber] = useState("");
    const bankAvailabilityTimer = useRef(null);

    useEffect(() => {
        const match = matchPath(location.pathname, {
            path: "/admin-panel/manage-mart/view-mart/:id",
            exact: true,
            strict: false,
        });

        if (match) {
            setReadOnlyMode(true);
        } else {
            setReadOnlyMode(false);
        }
    }, [location.pathname]);

    const [workingHours, setWorkingHours] = useState({
        monday_open: "", monday_close: "",
        tuesday_open: "", tuesday_close: "",
        wednesday_open: "", wednesday_close: "",
        thursday_open: "", thursday_close: "",
        friday_open: "", friday_close: "",
        saturday_open: "", saturday_close: "",
        sunday_open: "", sunday_close: ""
    });

    const handleTimeChange = (timeString, day, type) => {
        setWorkingHours((prev) => ({
            ...prev,
            [`${day}_${type}`]: timeString
        }));

        if (type === 'close' && workingHours[`${day}_open`]) {
            const fromTime = moment(workingHours[`${day}_open`], 'h:mm A');
            const toTime = moment(timeString, 'h:mm A');
            if (!toTime.isAfter(fromTime)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [day]: 'Closing time must be after opening time'
                }));
            } else {
                setErrors((prevErrors) => {
                    const newErrors = { ...prevErrors };
                    delete newErrors[day];
                    return newErrors;
                });
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleRadioInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value === "true", // Convert string to boolean
        }));
    };


    const handleThumbnailChange = async (event) => {
        const file = event.target.files[0];

        if (file && file.type.startsWith("image")) {
            const reader = new FileReader();
            reader.onload = () => {
                setThumbnailImage(reader.result);
            };
            reader.readAsDataURL(file);

            const formData = new FormData();
            formData.append("photo", file);

            axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/user/upload-pan-card`, formData)
                .then(response => {
                    if (response.status === 200) {
                        const uploadedFileName = response.data;
                        setFormData(prev => ({
                            ...prev,
                            thumbnailImage: uploadedFileName,
                        }));
                        setIsThumbnailPicValid(true);
                    } else
                        setIsThumbnailPicValid(false);

                })
                .catch(error => {
                    setIsThumbnailPicValid(false);
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        thumbnailImage: "Please upload a square image with minimum 425px x 425px.",
                    }));
                });
        }
    };

    // Cancel uploaded thumbnail
    const cancelThumbnail = () => {
        setThumbnailImage(null);
        setFormData(prev => ({
            ...prev,
            thumbnailImage: null,
        }));
        document.getElementById("thumbnail-input").value = ""; // Clear file input
    };

    const handlePanChange = async (event) => {
        const file = event.target.files[0];

        if (file && file.type.startsWith("image")) {
            const reader = new FileReader();
            reader.onload = () => {
                setPanImage(reader.result);
            };
            reader.readAsDataURL(file);

            const formData = new FormData();
            formData.append("photo", file);

            axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/user/upload-pan-card`, formData)
                .then(response => {
                    if (response.status === 200) {
                        setFormData(prev => ({
                            ...prev,
                            panImage: response.data,
                        }));
                    }
                })
                .catch(error => {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        panImage: "Please upload a valid Pan Image.",
                    }));
                });
        }
    };

    // Cancel uploaded PAN Image
    const cancelPanImage = () => {
        setPanImage(null);
        setFormData(prev => ({
            ...prev,
            panImage: null,
        }));
        document.getElementById("pan-input").value = ""; // Clear file input
    };

    const handleCertificateChange = async (index, field, file) => {
        const formData = new FormData();
        formData.append("photo", file);

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/user/upload-pan-card`, formData);

            if (response.status === 200) {
                handleCertifications(index, field, response.data);
            }
        } catch (error) {
            notifyUser("Error", "Failed to upload certificate image", "warning");
        }
    };


    const cancelCertificateImage = (index) => {
        setFormData((prev) => ({
            ...prev,
            certifications: prev.certifications.filter((_, i) => i !== index), // Remove the selected certification
        }));
    };

    const handleCertifications = (index, field, value) => {
        const updatedCertifications = [...formData.certifications];
        updatedCertifications[index] = {
            ...updatedCertifications[index],
            [field]: value,
        };
        setFormData({ ...formData, certifications: updatedCertifications });
    };


    const addCertificationField = () => {
        setFormData({
            ...formData,
            certifications: [...formData.certifications, { name: '', image: null }],
        });
    };

    const handleAccount = (e) => {
        if (bankAvailabilityTimer.current) clearTimeout(bankAvailabilityTimer.current);

        const updatedBankAccountNumber = e.target.value.toUpperCase();
        setBankAccountNumber(updatedBankAccountNumber);

        bankAvailabilityTimer.current = setTimeout(async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/abmgr/auth/check-bank-account-number?bankAccountNumber=${updatedBankAccountNumber}`
                );
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    bankAccountNumber: response.data,
                }));
            } catch (error) {
                console.error("Error checking bank account number:", error);
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    bankAccountNumber: "Unable to verify account number",
                }));
            }
        }, 1000);
    };


    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            if (bankAvailabilityTimer.current) clearTimeout(bankAvailabilityTimer.current);
        };
    }, []);


    const validateFormValues = (values) => {
        const errors = {};
        let isValid = true;

        // Helper functions for specific validations
        const isEmpty = (value) => !value;
        const isValidPhone = (contactNumber) => mobilenumberRegex.test(contactNumber); // Adjust regex as per requirement
        const isValidIFSC = (ifsc) => ifscRegex.test(ifsc); // Example IFSC regex
        const isValidPAN = (panNum) => pan.test(panNum); // Example PAN regex
        const isValidGST = (gst) => gstNumber.test(gst); // Example GST regex

        // Required field validations
        if (isEmpty(values.martName)) {
            isValid = false;
            errors.martName = 'Mart name is required';
        }
        if (isEmpty(values.businessDescription)) {
            isValid = false;
            errors.businessDescription = 'Business description is required';
        }
        if (!thumbnailImage) {
            isValid = false;
            errors.thumbnailImage = 'Thumbnail Image is required';
        }
        if (isEmpty(values.thumbnailDescription)) {
            isValid = false;
            errors.thumbnailDescription = 'Thumbnail description is required';
        }
        if (isEmpty(values.businessAddress)) {
            isValid = false;
            errors.businessAddress = 'Business address is required';
        }
        if (isEmpty(values.contactName)) {
            isValid = false;
            errors.contactName = 'Contact name is required';
        }
        if (formData.homeDeliveryAvailable === true && isEmpty(values.minOrderValue)) {
            isValid = false;
            errors.minOrderValue = 'Minimum order value is required';
        }
        if (!isValidPhone(values.contactNumber)) {
            isValid = false;
            errors.contactNumber = 'Valid phone number is required';
        }
        if (isEmpty(values.categories)) {
            isValid = false;
            errors.categories = 'At least one category is required';
        }
        if (isEmpty(values.subCategories)) {
            isValid = false;
            errors.subCategories = 'At least one subcategory is required';
        }
        // if (isEmpty(values.bankName)) {
        //     isValid = false;
        //     errors.bankName = 'Bank name is required';
        // }
        // if (isEmpty(values.accountHolderName)) {
        //     isValid = false;
        //     errors.accountHolderName = 'Account holder name is required';
        // }
        // if (isEmpty(values.bankAccountNumber)) {
        //     isValid = false;
        //     errors.bankAccountNumber = 'Bank account number is required';
        // }
        // if (!isValidIFSC(values.ifsc)) {
        //     isValid = false;
        //     errors.ifsc = 'Valid IFSC code is required';
        // }
        // if (!isValidPAN(values.panNum)) {
        //     isValid = false;
        //     errors.panNum = 'Valid PAN is required';
        // }
        // if (isEmpty(values.panImage)) {
        //     isValid = false;
        //     errors.panImage = 'PAN image is required';
        // }

        // Set errors and return overall validity
        setErrors(errors);
        return isValid;
    };

    useEffect(() => {
        const fetchAllCategories = async () => {
            try {
                let userId = authservice.getCurrentUser().id;
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/abmgr/category/get-mart-subcategories/${userId}`
                );

                const categoriesData = response.data;
                setAllCategories(categoriesData);
                // if (categoriesData.length > 0) {
                //     setFormData((prev) => ({
                //         ...prev,
                //         categories: [categoriesData[0].categoryId],
                //         subCategories: [categoriesData[0].subCategoryId]
                //     }));
                // }
                if (categoriesData.length > 0) {
                    setFormData((prev) => {
                        if (
                            (!prev.categories || prev.categories.length === 0) &&
                            (!prev.subCategories || prev.subCategories.length === 0)
                        ) {
                            return {
                                ...prev,
                                categories: [categoriesData[0].categoryId],
                                subCategories: [categoriesData[0].subCategoryId]
                            };
                        }
                        return prev; // no changes if already set
                    });
                }
                if (props.fullCategory) {
                    props.fullCategory(categoriesData);
                }
            } catch (error) {
                console.log(error, 'Getting data failed');
            }
        };

        fetchAllCategories();
    }, [props]);

    const showCategory = true;

    const handleNewCategory = (data) => {
        setAllCategories((prevCategories) => [...prevCategories, data]);
    };

    const handleCategoryChange = (selectedCategories) => {
        const categoriesArray = selectedCategories.map(category => category.value);
        setFormData(prev => ({
            ...prev,
            categories: categoriesArray
        }));
    };

    const handleSubCategoryChange = (selectedSubCategories) => {
        const subCategoriesArray = selectedSubCategories.map(subCategory => subCategory.value);
        setFormData(prev => ({
            ...prev,
            subCategories: subCategoriesArray
        }));
    };

    const handleSetCategoryValidationMethod = (m) => {
        setCategoryValidation(m);
    };

    const handleSetSubCategoryValidationMethod = (m) => {
        setSubCategoryValidation(m);
    };

    useEffect(() => {
        const fetchAllLocations = async () => {
            try {
                const [getFullAddress] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/getallstates`),
                ]);
                setAllLocations(getFullAddress.data);
                if (props.fullAddress) {
                    props.fullAddress(getFullAddress.data);
                }
            } catch (error) {
                console.log(error, 'Getting data failed');
            }
        };

        fetchAllLocations();
    }, [props]);

    const handleNewLocation = (data) => {
        setAllLocations((prevLocations) => [...prevLocations, data]);
    };

    const handleStateChange = (selectedStates) => {
        const statesArray = selectedStates.map(state => state.value);
        setFormData(prev => ({
            ...prev,
            states: statesArray
        }));
    };

    const handleCityChange = (selectedCities) => {
        const citiesArray = selectedCities.map(city => city.value);
        setFormData(prev => ({
            ...prev,
            cities: citiesArray
        }));
    };

    const handleLocalityChange = (selectedLocalities) => {
        const localitiesArray = selectedLocalities.map(locality => locality.value);
        setFormData(prev => ({
            ...prev,
            localities: localitiesArray
        }));
    };

    const handleNeighbourhoodChange = (selectedNeighbourhoods) => {
        const neighbourhoodArray = selectedNeighbourhoods.map(neighbourhood => neighbourhood.value);
        setFormData(prev => ({
            ...prev,
            neighbourhoods: neighbourhoodArray
        }));
    };

    useEffect(() => {
        if (location.state && location.state.mart) {
            setFormData({
                ...formData,
                ...location.state.mart,
            });
        }
    }, [location.state]);

    // Handle form submission
    const handleUpdate = async () => {
        // if (validateForm()) {
        try {
            const payload = Object.keys(workingHours).map(dayKey => {
                const [day, type] = dayKey.split("_"); // Extract day and type (open/close)
                return {
                    day,
                    openingTime: workingHours[`${day}_open`] || "",
                    closingTime: workingHours[`${day}_close`] || ""
                };
            }).reduce((acc, curr) => {
                // Group data by day
                let existing = acc.find(item => item.day === curr.day);
                if (existing) {
                    existing.openingTime = curr.openingTime;
                    existing.closingTime = curr.closingTime;
                } else {
                    acc.push(curr);
                }
                return acc;
            }, []);
            const isFormValid = validateFormValues(formData);
            const thumbnailImage = formData.thumbnailImage
                ? formData.thumbnailImage.split("/").pop()
                : formData.thumbnailImage;
            const panImage = formData.panImage
                ? formData.panImage.split("/").pop()
                : formData.panImage;
            // const certificateImage = formData.certificateImage
            //     ? formData.panImage.split("/").pop()
            //     : formData.certificateImage;\
            const martDTO = {
                id: formData.id,
                userId: authservice.getCurrentUserid(),
                name: formData.martName,
                businessDescription: formData.businessDescription,
                thumbnailImage: thumbnailImage,
                thumbnailDescription: formData.thumbnailDescription,
                businessAddress: formData.businessAddress,
                contactName: formData.contactName,
                contactNumber: formData.contactNumber,
                minOrderValue: formData.minOrderValue,
                // certifications: [],
                certifications: formData.certifications.map(cert => ({
                    name: cert.name,
                    image: cert.image,
                })),
                homeDeliveryAvailable: formData.homeDeliveryAvailable,
                // pickupAvailable: formData.pickupAvailable,
                workingHours: payload,
                categories: formData.categories,
                subCategories: formData.subCategories,
                country: 'India',
                states: formData.states,
                cities: formData.cities,
                localities: formData.localities,
                neighbourhoods: formData.neighbourhoods,
                bankName: formData.bankName,
                accountHolderName: formData.accountHolderName,
                bankAccountNumber: formData.bankAccountNumber,
                ifsc: formData.ifsc,
                pan: formData.panNum,
                panImage: panImage,
                panLinkWithAadhar: formData.panLinkWithAadhar,
                gstNumber: formData.gstNumber,
                lattitude: null,
                longitude: null,
                type: martType,

            };
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/update`,
                martDTO
            );
            if (response.status === 200) {
                notifyUser('Update mart', 'Your Mart Updated Successfully', type.SUCCESS)
                setFormVisible(false);
                history.push(`/mart/${authservice.getCurrentUserName()}`);
                setSubCategories(response.data.subCategories)
            }
        } catch (error) {
            console.error("Error updating mart:", error);
            notifyUser('Update Mart', 'Failed to update the mart', type.DANGER)
        }
        //}
    };



    useEffect(() => {
        const fetchLocationsAndMartData = async () => {
            try {
                const martResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/get-single-mart/${id}`);

                if (martResponse.status === 200) {
                    const imageUrl = martResponse.data.thumbnailImage
                        ? `${process.env.REACT_APP_IMAGES_URL}/${martResponse.data.thumbnailImage}`
                        : null;
                    const panImageUrl = martResponse.data.panImage
                        ? `${process.env.REACT_APP_IMAGES_URL}/${martResponse.data.panImage}`
                        : null;
                    const updatedCertifications = martResponse.data.certifications.map(cert => ({
                        ...cert,
                        image: cert.image ? `${cert.image}` : null,
                    }));
                    setSubCategories(martResponse.data.subCategories)

                    setFormData(prev => ({
                        ...prev,
                        ...martResponse.data,
                        martName: martResponse.data.name,
                        panNum: martResponse.data.pan,
                        thumbnailImage: imageUrl,
                        panImage: panImageUrl,
                        certificateImage: updatedCertifications,
                        subCategories: martResponse.data.subCategories
                    }));
                    setMartType(martResponse.data.type || '');
                    setThumbnailImage(imageUrl);
                    setPanImage(panImageUrl)
                    if (martResponse.data.workingHours) {
                        let formattedHours = {};

                        martResponse.data.workingHours.forEach(({ day, openingTime, closingTime }) => {
                            const dayLower = day.toLowerCase();
                            formattedHours[`${dayLower}_open`] = openingTime;
                            formattedHours[`${dayLower}_close`] = closingTime;
                        });
                        setWorkingHours(formattedHours);
                    }
                } else {
                    alert("Failed to fetch data.");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                alert("Error fetching data.");
            }
        };

        fetchLocationsAndMartData();
    }, [id]);



    return (
        <div className="admin-view-head">
            <div className="mt-4 g-2 col-md-12">
                <div className="col-md-2 add_button animated_back_button text-right">
                    <ButtonStyle type="button" className="form-control btn btn-block btn_font"
                        handleClick={() => props.history.goBack()}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
                </div>
                {!readOnlyMode && <TitleHeading text='Edit Mart' />}
                <Form.Group>
                    <div className="row col-md-10 justify-content-center p-1 ml-4">
                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                            <Form.Label>Mart Type*</Form.Label>
                        </div>
                        <div className="col-md-10">
                            <Form.Control
                                as="select"
                                value={martType}
                                onChange={(e) => {
                                    const selectedType = e.target.value;
                                    setMartType(selectedType);
                                }}
                                disabled={readOnlyMode}
                            >
                                <option value="" disabled hidden>Select Type</option>
                                <option value="SHOPPING">SHOPPING</option>
                                <option value="APPOINTMENT">APPOINTMENT</option>
                            </Form.Control>
                        </div>
                    </div>
                </Form.Group>

                <div className="p-3 border rounded bg-light">
                    <Form>
                        {/* Mart Name */}
                        <Form.Group>
                            <div className="row col-md-10 justify-content-center p-1 ml-4">
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                    <Form.Label>Mart Name*</Form.Label>
                                </div>
                                <div className="col-md-10">
                                    <Form.Control
                                        type="text"
                                        name="martName"
                                        value={formData.martName}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.martName}
                                        disabled={readOnlyMode}
                                    />
                                    {errors.martName && (
                                        <p style={{ color: "red" }}>{errors.martName}</p>
                                    )}
                                </div>
                            </div>
                        </Form.Group>

                        {/* Business Description */}
                        <Form.Group>
                            <div className="row col-md-10 justify-content-center p-1 ml-4">
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                    <Form.Label>Business Description*</Form.Label>
                                </div>
                                <div className="col-md-10">
                                    <Form.Control
                                        as="textarea"
                                        name="businessDescription"
                                        value={formData.businessDescription}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.businessDescription}
                                        disabled={readOnlyMode}
                                    />
                                    {errors.businessDescription && (
                                        <p style={{ color: "red" }}>{errors.businessDescription}</p>
                                    )}
                                </div>
                            </div>
                        </Form.Group>

                        <SetMartCategory
                            allCategories={allCategories}
                            showCategory={showCategory}
                            setCategoryValidationMethod={handleSetCategoryValidationMethod}
                            setSubCategoryValidationMethod={handleSetSubCategoryValidationMethod}
                            heading="Set Category"
                            // isMulti
                            disabled={readOnlyMode}
                            _handleNewCategory={handleNewCategory}
                            newFilterForm={true}
                            selectedCategories={formData.categories}
                            selectedSubCategories={subCategories}
                            _handleCategory={handleCategoryChange}
                            _handleSubCategory={handleSubCategoryChange}
                            wrapperClass="col-md-12"
                            labelClass="col-md-2"
                        />

                        <SetLocation
                            heading="Area Served"
                            isMulti
                            allLocations={allLocations}
                            _handleNewLocation={handleNewLocation}
                            newFilterForm={true}
                            //disabled={disable}
                            selectedStates={formData.states}
                            selectedCities={formData.cities}
                            selectedLocalities={formData.localities}
                            selectedNeighbourhoods={formData.neighbourhoods}
                            disabled={readOnlyMode}
                            _handleState={handleStateChange}
                            _handleCity={handleCityChange}
                            _handleLocality={handleLocalityChange}
                            _handleNeighbourhood={handleNeighbourhoodChange}
                            wrapperClass="col-md-12"
                            labelClass="col-md-2"
                        />

                        <Form.Group>
                            <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Thumbnail Image*</Form.Label></div>
                                <div className='col-md-10'>
                                    <div>
                                        <Form.Control
                                            type="file"
                                            name="thumbnailImage"
                                            onChange={handleThumbnailChange}
                                            accept="image/*"
                                            disabled={readOnlyMode}
                                            id="thumbnail-input"
                                        />
                                        {thumbnailImage && (
                                            <div className={sty.image_container}>
                                                <img src={thumbnailImage} alt="Thumbnail" className={sty.preview_image} />
                                                <button className={sty.cancel_btn} onClick={cancelThumbnail}>&times;</button>
                                            </div>
                                        )}
                                        {!isThumbnailPicValid && <p style={{ color: "red" }}>{errors.thumbnailImage}</p>}
                                    </div>
                                </div>
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Thumbnail Description*</Form.Label></div>
                                <div className='col-md-10'>
                                    <Form.Control
                                        as="textarea"
                                        name="thumbnailDescription"
                                        value={formData.thumbnailDescription}
                                        onChange={handleInputChange}
                                        disabled={readOnlyMode}
                                    />
                                    {errors.thumbnailDescription && <p style={{ color: "red" }}>{errors.thumbnailDescription}</p>}
                                </div>
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Business Address*</Form.Label></div>
                                <div className='col-md-10'>
                                    <Form.Control
                                        type='text'
                                        name="businessAddress"
                                        value={formData.businessAddress}
                                        onChange={handleInputChange}
                                        disabled={readOnlyMode}
                                        required
                                    />
                                    {errors.businessAddress && <p style={{ color: "red" }}>{errors.businessAddress}</p>}
                                </div>
                            </div>
                        </Form.Group>

                        <div className='col-md-10 justify-content-center p-1 ml-4'>
                            <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Working Hours*</Form.Label></div>
                            {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => (
                                <div key={day} className="col-md-10">
                                    <label className="col-md-2 text-md-right text-left">{day.charAt(0).toUpperCase() + day.slice(1)}</label>
                                    <TimePicker use12Hours format="h:mm A" minuteStep={1}
                                        value={workingHours[`${day}_open`] ? moment(workingHours[`${day}_open`], 'h:mm A') : null}
                                        onChange={(time, timeString) => handleTimeChange(timeString, day, 'open')}
                                        placeholder="Select AM/PM"
                                        defaultOpenValue={moment('12:00 AM', 'h:mm A')}
                                    />&nbsp; &nbsp;
                                    <TimePicker use12Hours format="h:mm A" minuteStep={1}
                                        value={workingHours[`${day}_close`] ? moment(workingHours[`${day}_close`], 'h:mm A') : null}
                                        onChange={(time, timeString) => handleTimeChange(timeString, day, 'close')}
                                        placeholder="Select AM/PM"
                                        defaultOpenValue={moment('12:00 AM', 'h:mm A')}
                                    />
                                    {errors[day] && <p style={{ color: 'red' }}>{errors[day]}</p>}
                                </div>
                            ))}
                        </div>

                        {/* Contact Name */}
                        <Form.Group>
                            <div className="row col-md-10 justify-content-center p-1 ml-4">
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                    <Form.Label>Contact Name*</Form.Label>
                                </div>
                                <div className="col-md-10">
                                    <Form.Control
                                        type="text"
                                        name="contactName"
                                        value={formData.contactName}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.contactName}
                                        disabled={readOnlyMode}
                                    />
                                    {errors.contactName && (
                                        <p style={{ color: "red" }}>{errors.contactName}</p>
                                    )}
                                </div>
                            </div>
                        </Form.Group>

                        {/* Contact Number */}
                        <Form.Group>
                            <div className="row col-md-10 justify-content-center p-1 ml-4">
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                    <Form.Label>Contact Number*</Form.Label>
                                </div>
                                <div className="col-md-10">
                                    <Form.Control
                                        type="tel"
                                        name="contactNumber"
                                        value={formData.contactNumber}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.contactNumber}
                                        disabled={readOnlyMode}
                                    />
                                    {errors.contactNumber && (
                                        <p style={{ color: "red" }}>{errors.contactNumber}</p>
                                    )}
                                </div>
                            </div>
                        </Form.Group>

                        {martType === 'SHOPPING' && (
                            <>
                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Free Home Delivery</Form.Label></div>
                                        <div className='col-md-10'>
                                            <div className='row p-2'>
                                                <div className='pl-2'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="Yes"
                                                        name="homeDeliveryAvailable"
                                                        value={true}
                                                        checked={formData.homeDeliveryAvailable === true}
                                                        onChange={handleRadioInputChange}
                                                        disabled={readOnlyMode}
                                                    />
                                                </div>
                                                <div className='pl-2'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="No"
                                                        name="homeDeliveryAvailable"
                                                        value={false}
                                                        checked={formData.homeDeliveryAvailable === false}
                                                        onChange={handleRadioInputChange}
                                                        disabled={readOnlyMode}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>

                                {formData.homeDeliveryAvailable === true && (
                                    <Form.Group>
                                        <div className="row col-md-10 justify-content-center p-1 ml-4">
                                            <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                                <Form.Label>Minimum Order Value*</Form.Label>
                                            </div>
                                            <div className="col-md-10">
                                                <Form.Control
                                                    type="tel"
                                                    name="minOrderValue"
                                                    value={formData.minOrderValue}
                                                    onChange={handleInputChange}
                                                    isInvalid={!!errors.minOrderValue}
                                                    disabled={readOnlyMode}
                                                />
                                                {errors.minOrderValue && (
                                                    <p style={{ color: "red" }}>{errors.minOrderValue}</p>
                                                )}
                                            </div>
                                        </div>
                                    </Form.Group>
                                )}
                            </>)}

                        {/* <Form.Group>
                            <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Pickup Available</Form.Label></div>
                                <div className='col-md-10'>
                                    <div className='row p-2'>
                                        <div className='pl-2'>
                                            <Form.Check
                                                type="radio"
                                                label="Yes"
                                                name="pickupAvailable"
                                                value={true}
                                                checked={formData.pickupAvailable === true}
                                                onChange={handleRadioInputChange}
                                                disabled={readOnlyMode}
                                            />
                                        </div>
                                        <div className='pl-2'>
                                            <Form.Check
                                                type="radio"
                                                label="No"
                                                name="pickupAvailable"
                                                value={false}
                                                checked={formData.pickupAvailable === false}
                                                onChange={handleRadioInputChange}
                                                disabled={readOnlyMode}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form.Group> */}

                        {authservice.getAccountType() === 'SUB_USER' ? null :
                            <>

                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Bank Name</Form.Label></div>
                                        <div className='col-md-10'>
                                            <Form.Control
                                                type="text"
                                                name="bankName"
                                                value={formData.bankName}
                                                onChange={handleInputChange}
                                                //required
                                                disabled={readOnlyMode}
                                            />
                                            {errors.bankName && <p style={{ color: "red" }}>{errors.bankName}</p>}
                                        </div>
                                    </div>
                                </Form.Group>

                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Account Holder Name</Form.Label></div>
                                        <div className='col-md-10'>
                                            <Form.Control
                                                type="text"
                                                name="accountHolderName"
                                                value={formData.accountHolderName}
                                                onChange={handleInputChange}
                                                //required
                                                disabled={readOnlyMode}
                                            />
                                            {errors.accountHolderName && <p style={{ color: "red" }}>{errors.accountHolderName}</p>}
                                        </div>
                                    </div>
                                </Form.Group>

                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Bank Account Number</Form.Label></div>
                                        <div className='col-md-10'>
                                            <Form.Control
                                                type="text"
                                                name="bankAccountNumber"
                                                value={formData.bankAccountNumber}
                                                onChange={handleAccount && handleInputChange}
                                                //required
                                                disabled={readOnlyMode}
                                            />
                                            {errors.bankAccountNumber && <p style={{ color: "red" }}>{errors.bankAccountNumber}</p>}
                                        </div>
                                    </div>
                                </Form.Group>

                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>IFSC Code</Form.Label></div>
                                        <div className='col-md-10'>
                                            <Form.Control
                                                type="text"
                                                name="ifsc"
                                                value={formData.ifsc}
                                                onChange={handleInputChange}
                                                //required
                                                disabled={readOnlyMode}
                                            />
                                            {errors.ifsc && <p style={{ color: "red" }}>{errors.ifsc}</p>}
                                        </div>
                                    </div>
                                </Form.Group>

                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>PAN</Form.Label></div>
                                        <div className='col-md-10'>
                                            <Form.Control
                                                type="text"
                                                name="panNum"
                                                value={formData.panNum}
                                                onChange={handleInputChange}
                                                //required
                                                disabled={readOnlyMode}
                                            />
                                            {errors.panNum && <p style={{ color: "red" }}>{errors.panNum}</p>}
                                        </div>
                                    </div>
                                </Form.Group>
                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                            <Form.Label>PAN Image</Form.Label>
                                        </div>
                                        <div className='col-md-10'>
                                            {/* {formData.panImage && (
                                        <div>
                                            <img
                                                src={`${process.env.REACT_APP_IMAGES_URL}/${formData.panImage}`}
                                                alt="Pan Image"
                                                style={{ width: '200px', height: 'auto', marginBottom: '10px' }}
                                            />
                                        </div>
                                    )} */}
                                            {/* File input for uploading new Pan Image */}
                                            <Form.Control
                                                type="file"
                                                name="panImage"
                                                onChange={handlePanChange}
                                                accept="image/*"
                                                disabled={readOnlyMode}
                                                id='pan-input'
                                            />
                                            {panImage && (
                                                <div className={sty.image_container}>
                                                    <img src={panImage} alt="PAN" className={sty.preview_image} />
                                                    <button className={sty.cancel_btn} onClick={cancelPanImage}>&times;</button>
                                                </div>
                                            )}
                                            {/* {errors.panImage && <p style={{ color: "red" }}>{errors.panImage}</p>} */}
                                        </div>
                                    </div>
                                </Form.Group>


                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>Pan Link with Aadhar</Form.Label></div>
                                        <div className='col-md-10'>
                                            <div className='row p-2'>
                                                <div className='pl-2'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="Yes"
                                                        name="panLinkWithAadhar"
                                                        value={true}
                                                        checked={formData.panLinkWithAadhar === true}
                                                        onChange={handleRadioInputChange}
                                                        disabled={readOnlyMode}
                                                    />
                                                </div>
                                                <div className='pl-2'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="No"
                                                        name="panLinkWithAadhar"
                                                        value={false}
                                                        checked={formData.panLinkWithAadhar === false}
                                                        onChange={handleRadioInputChange}
                                                        disabled={readOnlyMode}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>

                                <Form.Group>
                                    <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                        <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}><Form.Label>GST Number</Form.Label></div>
                                        <div className='col-md-10'>
                                            <Form.Control
                                                type="text"
                                                name="gstNumber"
                                                value={formData.gstNumber}
                                                onChange={handleInputChange}
                                                disabled={readOnlyMode}
                                            />
                                            {errors.gstNumber && <p style={{ color: "red" }}>{errors.gstNumber}</p>}
                                        </div>
                                    </div>
                                </Form.Group>
                            </>}

                        <Form.Group>
                            <div className='row col-md-10 justify-content-center p-1 ml-4'>
                                <div className={`${style.addpost_label} col-md-2 text-md-right text-left`}>
                                    <Form.Label>Certifications</Form.Label>
                                </div>
                                <div className='col-md-10'>
                                    {/* {formData.certifications.map((cert, index) => (
                                        <div key={index}>

                                            <Form.Control
                                                type="text"
                                                placeholder="Certification Name"
                                                value={cert.name}
                                                disabled={readOnlyMode}
                                                onChange={(e) =>
                                                    handleCertifications(index, 'name', e.target.value)
                                                }
                                                className="mb-2"
                                            />
                                            {cert.image && (
                                                <div className={sty.image_container}>
                                                    <img src={cert.image} alt={`Certification ${index}`} className={sty.preview_image} />
                                                    <button className={sty.cancel_btn} onClick={() => cancelCertification(index)}>&times;</button>
                                                </div>
                                            )}

                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                disabled={readOnlyMode}
                                                onChange={(e) =>
                                                    handleCertificateChange(index, 'image', e.target.files[0])
                                                }
                                            />
                                        </div>
                                    ))} */}
                                    {formData.certifications.map((cert, index) => (
                                        <div key={index} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                placeholder="Certification Name"
                                                value={cert.name}
                                                onChange={(e) =>
                                                    handleCertifications(index, 'name', e.target.value)
                                                }
                                                className="mb-2"
                                            />
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) =>
                                                    handleCertificateChange(index, 'image', e.target.files[0])
                                                }
                                            />
                                            {cert.image && (
                                                <div className={sty.image_container}>
                                                    <img src={`${process.env.REACT_APP_IMAGES_URL}/${cert.image}`} alt={`Certification ${index}`} className={sty.preview_image} />
                                                    {index === formData.certifications.length - 1 && ( // Only show for the last item
                                                        <button className={sty.cancel_btn} onClick={() => cancelCertificateImage(index)}>&times;</button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                    <div className="popup-buttons">
                                        <Button className="secondary" variant="secondary" onClick={addCertificationField}>
                                            Add Certifications
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Form.Group>


                        {/* Buttons */}
                        <div className="popup-buttons">
                            <Button variant="primary" onClick={handleUpdate} className="secondary" disabled={readOnlyMode}>
                                Save Changes
                            </Button>
                            <Button
                                variant="secondary" disabled={readOnlyMode}
                                onClick={() => history.push(`/mart/${authservice.getCurrentUserName()}`)}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
            {!readOnlyMode && <>
                <div className={`listings row ${styles.large_rect}`}>
                    <LargeRectangle spot={"-1"} />
                </div>
                <div className={`${styles.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
                    <BillBoard spot={"-1"} />
                </div></>}

        </div>
    );
};

export default EditMart;
